module.exports = require("@babel/runtime/core-js/object/freeze");